'use client';

import { PALETTE, NODE_SPECS } from '@/lib/pipeline/registry';
import { usePipelineStore } from '@/lib/pipeline/store';
import { type NodeCategory } from '@/lib/pipeline/types';

const GROUP_ORDER: NodeCategory[] = ['Input', 'Generator', 'Operator', 'Draw', 'Output'];

export default function NodePalette() {
  const addNode = usePipelineStore((s) => s.addNode);

  const groups = GROUP_ORDER.map((cat) => ({
    cat,
    types: PALETTE.filter((t) => NODE_SPECS[t]?.category === cat),
  })).filter((g) => g.types.length > 0);

  return (
    <div className="p-3 space-y-4">
      <h2 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wider">Nodes</h2>

      {groups.map((g) => (
        <div key={g.cat}>
          <div className="text-[10px] font-semibold text-[var(--text-muted)] uppercase tracking-wider mb-1.5 px-0.5">
            {g.cat}
          </div>
          <div className="space-y-1.5">
            {g.types.map((type) => {
              const spec = NODE_SPECS[type];
              return (
                <button
                  key={type}
                  onClick={() => addNode(type)}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('application/reactflow', type);
                    e.dataTransfer.effectAllowed = 'move';
                  }}
                  className="w-full text-left px-3 py-1.5 rounded-lg bg-[var(--bg-elevated)] border border-[var(--border-subtle)] hover:border-[var(--accent)] transition-subtle cursor-grab active:cursor-grabbing text-sm"
                >
                  {spec.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      <p className="text-[11px] text-[var(--text-muted)] leading-relaxed">
        Click or drag a node onto the canvas. Drag colored sockets to wire nodes; press Run. Select a
        node/edge and hit Delete to remove it.
      </p>
    </div>
  );
}
